module.exports = __webpack_public_path__ + "img/modal-document-create-fl.53acb10e.svg";